import PropTypes from 'prop-types';
import classNames from 'classnames';
import CircularProgress from '@mui/material/CircularProgress';
import get from 'lodash/get';
import find from 'lodash/find';
import {
  FieldGroup,
  FieldGroupItem,
  Field2 as Field,
} from 'vibeguide';

function ProfileExternalIDRow({
  className = '',
  style = {},
  // id,
  // source,
  // extId,
  // error,
  index,
  item = {},
  disableInput = false,
  showLabels = false,
  allowRemove = false,
  alignColumns = false,
  onRemove = () => {},
  isNew = false,
  options = [],
  onChangeSource = () => {},
  onChangeId = () => {},
}) {
  return (
    <FieldGroup
      className={classNames('ExternalIDRow', className)}
      style={style}
      id={item.extId}
      allowRemove={allowRemove}
      alignColumns={alignColumns}
      removeTooltip="Remove External ID"
      onRemove={(id) => onRemove(id, item.source, index)}
    >
      {!item.saving ? (
        <>
          <FieldGroupItem>
            {isNew ? (
              <Field
                rootClassName="location-input location-provider"
                type="select"
                label={showLabels
                  ? 'Source'
                  : null}
                name="name"
                error={item.sourceError}
                options={options}
                value={item.source}
                dataId={item._id}
                testId={`profile-external-id-${item._id}-source-select`}
                onChange={onChangeSource}
              />
            ) : (
              <Field
                type="text"
                label={showLabels
                  ? 'Source'
                  : null}
                name="source"
                placeholder="Source"
                error={item.sourceError}
                value={get(find(options, { value: item.source }), 'label') || item.source}
                disabled={disableInput}
                testId={`profile-external-id-${item._id}-source-input`}
              />
            )}
          </FieldGroupItem>

          <FieldGroupItem>
            <Field
              type="text"
              label={showLabels
                ? 'External ID'
                : null}
              name="extId"
              placeholder="External ID"
              value={item.extId}
              disabled={!isNew}
              error={item.showError || item.extIdError}
              dataId={item._id}
              testId={`profile-external-id-${item._id}-id-input`}
              onChange={onChangeId}
            />
          </FieldGroupItem>
        </>
      ) : (
        <FieldGroupItem>
          <div className="external-id-saving">
            <span className="external-id-saving-text">Saving...</span>
            <CircularProgress
              color="inherit"
              size={16}
              style={{
                marginLeft: 4,
                display: 'flex',
              }}
            />
          </div>
        </FieldGroupItem>
      )}
    </FieldGroup>
  );
}

ProfileExternalIDRow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  // id: PropTypes.string.isRequired,
  // source: PropTypes.string,
  // extId: PropTypes.string,
  item: PropTypes.object,
  disableInput: PropTypes.bool,
  showLabels: PropTypes.bool,
  allowRemove: PropTypes.bool,
  alignColumns: PropTypes.bool,
  onRemove: PropTypes.func,
  isNew: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.object),
  onChangeSource: PropTypes.func,
  onChangeId: PropTypes.func,
};

export default ProfileExternalIDRow;
